module.exports = __webpack_public_path__ + "img/知识产权法.d7494908.png";